import { Component } from "react";
import paginaError from '../../images/error.jpg'


export default class PaginaError extends Component {
  render() {
    return <main style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

      <div style={{ width: "50%", height: "50%" }}>
        <img src={paginaError} alt="Page not found"  style={{width:"100%", height:"100%"}} />
      </div>

    </main>
  }
}